// import { useEffect } from 'react';

// const PopUnderAd = () => {
//   useEffect(() => {
//     // This function will trigger a pop-under ad
//     // Replace this with your actual ad network code
//     const triggerPopUnder = () => {
//       // Example: You can integrate your ad network's pop-under code here
//       // For demonstration, this opens a new window (you'll replace with your ad code)

//       /*
//       // Example integration with ad networks:

//       // PropellerAds example:
//       // (function(d,z,s){s.src='https://'+d+'/400/'+z;try{(document.body||document.documentElement).appendChild(s)}catch(e){}})('your-zone-id.com',123456,document.createElement('script'))

//       // Or other ad networks like PopAds, PopCash, etc.
//       // Follow their integration instructions
//       */

//       console.log('Pop-under ad triggered');
//       // Your ad network code goes here
//     };

//     // Trigger the pop-under ad once when component mounts
//     const timer = setTimeout(() => {
//       triggerPopUnder();
//     }, 500);

//     return () => clearTimeout(timer);
//   }, []);

//   return null; // This component doesn't render anything visible
// };

// export default PopUnderAd;

import { useEffect } from 'react';

const PopUnderAd = () => {
  useEffect(() => {
    // Script tag အသစ်တစ်ခု ဖန်တီးခြင်း
    const script = document.createElement('script');

    // Adsterra ကပေးထားသော Source Link
    // script.src = "https://pl28678788.effectivegatecpm.com/bc/68/94/bc68942ceae1fda7e18f1d73cd1dd36b.js";
    script.src = "https://pl31658003.profitableratecpmnetwork.com/cc/98/96/cc98962ab00725f5570b0111f081c388.js"
    script.type = 'text/javascript';
    script.async = true;

    // Head သို့မဟုတ် Body ထဲသို့ ထည့်သွင်းခြင်း
    document.body.appendChild(script);

    return () => {
      // Component ပိတ်သွားလျှင် Script ကို ပြန်ဖျက်ပေးရန် (Cleanup)
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return null; // ဘာမှ Render လုပ်စရာမလိုပါ
};

export default PopUnderAd;